import { AxiosInstance } from 'axios'

type DocumentsDto = {
  data: {
    id: number
    attributes: {
      createdAt: string
      updatedAt: string
      documents_title: string
      content_title: string
      section: Section[]
    }
  }
  meta: Record<string, unknown>
}

type Section = {
  id: number
  Title: string
  document: DocumentEntry[]
}

type DocumentEntry = {
  id: number
  title: string
  file: {
    data: FileData[]
  }
}

type FileData = {
  id: number
  attributes: FileAttributes
}

type FileAttributes = {
  name: string
  alternativeText: string | null
  caption: string | null
  width: number | null
  height: number | null
  formats: unknown | null
  hash: string
  ext: string
  mime: string
  size: number
  url: string
  previewUrl: string | null
  provider: string
  provider_metadata: unknown | null
  createdAt: string
  updatedAt: string
}

export interface GetDocumentsArgs {
  locale: string
}

export const getDocuments = async (
  client: AxiosInstance,
  { locale }: GetDocumentsArgs,
): Promise<DocumentsDto['data']['attributes']> => {
  const path = '/documents-page'
  const params = {
    locale,
    populate: {
      section: {
        fields: ['id', 'title'],
        populate: {
          document: {
            fields: ['id', 'title'],
            populate: {
              file: { populate: '*' },
            },
          },
        },
      },
    },
  }
  return (await client.get<DocumentsDto>(path, { params })).data.data.attributes
}
